import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export type GetConversationByToken = (
  token: string,
) => Promise<{ data: Conversation }>;

export default (makeCall: MakeCall) => (token: string) =>
  makeCall<Conversation>('GET', `${APIV2_URL}/conversations/token/${token}`);
